import React, { useEffect, useState } from "react"
import { EDUCATION_LINK, HEADING_LINK, POPUP_TYPES, SKILLS_LINK, SKIP_CONFIRMATION_BOX_CONTENT, SUMMARY_LINK, WORKHISTORY_LINK, FINAL_RESUME, WORKHISTORY_TIPS_LINK, EDUCATION_TIPS_LINK, SKILL_TIPS_LINK, SUMMARY_TIPS_LINK, APP_DOMAIN } from "../../constants/constants";
import { usePopup } from "../../context/PopupContext";
import { useResume } from "../../context/ResumeContext";
import ArrowUpDir from '../../assets/images/top-dir-arrow.svg';
import IconGrid from '../../assets/images-new/icons/window-grid.svg';
import WpAPI from "../../WpApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { removeBodyScroll } from "../../helper";

const TraditionalEditorActions = (props) => {
    const history = useHistory();
    const {
        resume,
      setShowPreview,
        handlers: { 
          onSkipClick,
          onNextClick,
          onBackClick,
          onsaveResume
        },
        skip_label,
        next_clicked,
        next_label,
       } = useResume();
    const confirmbox = usePopup();
    const [loader, setLoader] = useState(false);
    const [showBack, setShowBack] = useState(false);
    const [showAddSkip, setShowAddSkip] = useState(false);
    const [saved, setSaved] = useState(false);
    const [showTemplateButton, setShowTemplateButton] = useState(true);

    useEffect(() => {
        // if (props.resume.hasOwnProperty('created_date') && props.resume.enabled_tabs.length > 1 && !props.resume.created_date.length) setRedirect(true)
        // checkSectionSkipped()
        if (document.location.pathname != HEADING_LINK) {
          setShowBack(true);
        } else {
          setShowBack(false);
        }
        setShowAddSkip([WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK].includes(location.pathname));
        // setShowTemplateButton(![ WORKHISTORY_TIPS_LINK, EDUCATION_TIPS_LINK, SKILL_TIPS_LINK , SUMMARY_TIPS_LINK].includes(location.pathname));
      });
      useEffect(() => {
        confirmbox.configurePopup(POPUP_TYPES);
      }, []);
    const saveData = () => {
        onsaveResume();
        let isLogin = WpAPI.isLoggedIn();
        if (isLogin) {
          setLoader(true);
          setSaved(true);
          setTimeout(() => {
            setLoader(false);
          }, 1000);
        } else {
          props.showPopup(!props.popup);
          //WpAPI.setRedirectCookie(window.location.pathname);
          //window.location.href = '/membership-levels/'
          gaTrack('RT App', `Editor`, `Login/Signup Popup`);
          ga4Track('app_editor_save_button_popup', 'RT App', 'Login/Signup Popup');
        }
        gaTrack('RT App', `Editor`, `Save Resume`);
        ga4Track('app_editor_save', 'RT App', 'Save Resume');
    }

    if(saved){
      setTimeout(() => {
        setSaved(false)
      }, 2000)
    }
    
    return <>
        <div className={`editor-controls${props.showTemplates ? ' editor-template-view' : ""}`}>
          <div className="templates">
          { showTemplateButton && 
            <div className="button button-1 ai-btn-adjustment">
            {!props.showTemplates 
                ? <>
                <div className="change-templ-action round-btn round-btn-border"
                  onClick={() => {
                    ga4Track(
                      "app_te_templates_open",
                      "RB App",
                      "Traditional Editor: Open Template Selector"
                    );
                    props.setShowTemplates(true);
                }}>
                  <i className="new-icon-grid"><IconGrid /></i>
                    <span>Templates</span>
                    
                  </div>

                  {/* {!props.showAIAssistant && !location.pathname.includes('details') && (
                    <div className="change-templ-action round-ai-btn round-btn-border"
                      onClick={() => {
                        props.setShowAIAssistant(!props.showAIAssistant)
                    }}>
                    AI Assistant
                    <img src={`${APP_DOMAIN}/assets/images-new/icons/ai-assistant-icon.svg`} alt="icon assistant" />
                    </div>
                  )} */}

                  </>
                : <>
                
                <div className="change-templ-action round-btn  round-btn-border btn-close-done" 
                  onClick={() => {
                    ga4Track(
                      "app_te_templates_close",
                      "RB App",
                      "Traditional Editor: Close Template Selector"
                    );
                    props.setShowTemplates(false);
                }}> 
                    <i className="icon-cross-icon"></i> 
                    <span>Close</span>
              </div></>}
            </div>
          }
         
          </div>
          
            <div className="controls">

          <div className="editor-btn btn-preview" onClick={() => {
            setShowPreview(true);
            removeBodyScroll(true);
          }}>
            <i className="icon-eye"></i><span>Preview</span>
          </div>
            {showBack && <div className="round-btn  round-btn-border btn-back"
              onClick={() => {
                {props.showTemplates && props.setShowTemplates(false)}
                localStorage.setItem('referrer', window.location.pathname);
                history.push({
                  state: {
                    openPanel: true
                  }
                })
                onBackClick();
                gaTrack('RT App', `Editor`, `Back: ${skip_label}`);
                let ga_cat = 'app_editor_back_' + (skip_label).replace(' ', '_');
                ga4Track(ga_cat, 'RT App', `Back: ${skip_label}`);
              }}>
              <i className="arrow-bar-left"></i><span>Back</span>
            </div>}

          {
          // Task 976
          /* <div className={`round-btn btn-save${saved ? ' saved' : ''}`} onClick={saveData}>
            {saved ? <><i className="icon-tick-light"></i><span>Saved!</span></> : <><i className="icon-save"></i><span>Save</span></>}
          </div> */}
          {showAddSkip && <div className="round-btn round-btn-no-border btn-skip"
                 onClick={(e) => {
                  {props.showTemplates && props.setShowTemplates(false)}
                    if (skip_label.toLowerCase() !== 'add') {
                    //   setCustomBox(true)
                    confirmbox.show('section_skip',null,() => onSkipClick())
                    gaTrack('RT App', `Editor`, `Skip: ${skip_label}`);
                    let ga_cat = 'app_editor_skip_' + (skip_label).replace(' ', '_');
                    ga4Track(ga_cat, 'RT App', `Skip: ${skip_label}`);
                    // onSkipClick();
                    } else {
                      onSkipClick();
                    }
                    removeBodyScroll(true);
                  }}
                ><span>{skip_label}</span><i className="icon-double-arrow-right"></i></div>}
          <div className={`round-btn round-btn-fill btn-next${(resume.enabled_tabs.includes('heading') ? ' btn-next-active' : '')}`}
            onClick={(e) => {
              {props.showTemplates && props.setShowTemplates(false)}
              if (window.location.pathname.includes('additional-sections')) {
                localStorage.setItem('referrer', window.location.pathname);
                history.push({
                  state: {
                    openPanel: true
                  }
                })
              }
              onNextClick();
              gaTrack('RT App', `Editor`, `${next_label}`);
              let ga_cat = 'app_editor_' + (next_label).replace(' ', '_');
              ga4Track(ga_cat, 'RT App', `${next_label}`);
              e.stopPropagation();
            }}
          >
            <span>Next</span><i className="arrow-bar-right"></i>
          </div>

            </div>
        </div>
        <div className="preview-resume-btn">
          <div className="blue-preview-btn" onClick={() => history.push({
              pathname: FINAL_RESUME,
              state: {
                  openPanel: true,
                  referrer: history.location.pathname
              }
          })}>Preview Resume <span className="display-up-icon"><ArrowUpDir></ArrowUpDir></span></div>
        </div>     
    </>
}
export default TraditionalEditorActions